import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import ListaNcmService from "./listaNcmService"
import FormList from 'base/FormList'

export default function ListaNcmList() {

    const [service] = useState(() => new ListaNcmService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_linc',
        dsName: 'descricao_linc',
        mainField: { name: 'descricao_linc', label: 'Descrição' },
        advFields: [
            { name: 'codigo_linc', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'cod_tilin_linc', label: 'Lista de NCM', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_linc', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_linc" sortable header="Código"></Column>
            <Column field="descricao_linc" sortable header="Descrição"></Column>
        </FormList >
    )
}
